import { useRouter } from "next/router";
import NextImage from "../global/NextImage";

const Logo = ({ className }) => {
  const { locale } = useRouter();
  return (
    <NextImage
      src={
        process.env.NEXT_PUBLIC_CUSTOM_COLOR
          ? `/imgs/snd_logo_${locale}.png`
          : `/imgs/aw_logo_${locale}.png`
      }
      // src={`/imgs/snd_logo_${locale}.png`}
      // width={100}
      // height={100}
      fill
      // className={`w-24 transition-all duration-500 object-contain ${
      className={`w-24 transition-all duration-500 object-contain ${
        className || ""
      }`}
    />
  );
};
export default Logo;
